import creator from "./creator";
import select from "./select";

export default function(name) {
  return select(creator(name).call(document.documentElement));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/create.js
// module id = 385
// module chunks = 0 1 2 3 4